module.exports = __webpack_public_path__ + "static/media/product-bg-3.f9259469.png";